import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/config/i18n";
import "@mdi/font/css/materialdesignicons.css";
import "@/temp-fusion-style/overrides.scss";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    themes: {
      light: {
        primary: "#454f54", // Persis 700
        secondary: "#455a64",
        error: "#ff0011",
        warning: "#ffc107",
        success: "#0eb939",
        info: "#00bbff",
        background: "#fff", // Default Content Hintergrund Farbe
        anchor: "#1269ec", // Link Farbe
        highlight: "#ffffbb",
        "btn-primary": "#007bff", // Fusion Primary Blau
        "ci-alpha": "#d4003c", // Persis Rot
        "ci-beta": "#1269ec", // Persis Blau
        "ci-gamma": "#5c6970" // Persis Grau
      }
    }
  }
});
